import React, { AnchorHTMLAttributes, FC, ReactNode } from 'react'
import Link from 'next/link'
import { FlattenSimpleInterpolation } from 'styled-components'

import htmlToReact from '@/utils/html-to-react'

import { PolicyWrapper } from './elements'

const localLink = /^https:\/\/liv.rent/g

interface ClientSideLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string
  key: number
  rel: string
  target: string
  children: any
}

type InstructionsProps = Omit<ClientSideLinkProps, 'children'>

const ClientSideLink = ({ href, children, ...props }: ClientSideLinkProps) => {
  const to = href.replace(localLink, '') || '/'

  return (
    <Link href={to} passHref {...props}>
      {children}
    </Link>
  )
}

interface InstructionsItem {
  shouldProcessNode: (node: any) => boolean
  processNode: (node: any, children: ReactNode, index: number) => ReactNode
}

const instructions: InstructionsItem[] = [
  {
    /** FOR CLIENT SIDE-LINK */
    shouldProcessNode: node =>
      node.name === 'a' &&
      node.attribs &&
      node.attribs.href &&
      !!node.attribs.href.match(localLink),
    // eslint-disable-next-line react/display-name
    processNode: (node, children, index) =>
      React.createElement(
        ClientSideLink as FC<InstructionsProps>,
        {
          key: index,
          href: node.attribs.href,
          rel: node.attribs.rel,
          target: node.attribs.target
        },
        children
      )
  }
]

interface PolicyProps {
  description: string
  replaceLinks?: boolean
  customStyle?: FlattenSimpleInterpolation
}

const Policy = ({ description, replaceLinks = true, ...rest }: PolicyProps) => (
  <PolicyWrapper {...rest}>
    {htmlToReact(description, replaceLinks ? { instructions } : {})}
  </PolicyWrapper>
)

export default Policy
